import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpHeaders,
  HttpInterceptor,
  HttpRequest
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AccountJwtService } from "@youm-front/account-jwt/data-access";
import { NoticeFacade } from "@youm-front/notice/data-access";
import { EMPTY, Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { ApiFacade } from "../facades";
import { API_IGNORE_ERROR } from "../../tokens";

@Injectable()
export class ApiInterceptor implements HttpInterceptor {
  constructor(
    private readonly accountJwtService: AccountJwtService,
    private readonly apiFacade: ApiFacade,
    private readonly noticeFacade: NoticeFacade
  ) {}

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const { accountJwt } = this.accountJwtService;
    const apiIgnoreError = req.context.get(API_IGNORE_ERROR);

    let headers = new HttpHeaders();

    if (accountJwt) {
      headers = headers.set("Authorization", `Bearer ${accountJwt}`);
    }

    const auth = req.clone({
      headers
    });

    return next
      .handle(auth)
      .pipe(catchError((_) => (apiIgnoreError ? EMPTY : this.onError(_))));
  }

  private onError = (response: HttpErrorResponse) => {
    // A network-level failure (no response body, e.g. connection refused/timeout) can
    // legitimately hand this a null/undefined error - reading error.code on it crashed
    // (confirmed, regression-tested in api.interceptor.spec.ts).
    const { error, message } = response;
    const errorOrEmpty = error ?? {};

    if (errorOrEmpty.code === 1401) {
      this.apiFacade.error(error);
    } else {
      // TODO https://liveedev.atlassian.net/browse/YOUM-235
      // this.noticeFacade.noticeCreate(
      //   new NoticeCreate1Cmd({
      //     kind: "error",
      //     data: `${message} (${JSON.stringify(error)})`
      //   })
      // );
      console.error(message, error);
    }

    return throwError(response);
  };
}
